export class DocumentUpload {
  id: string;
  upload_url: string;
}
